const privacyLinks = {
  de: "/de/datenschutz",
  en: "/en/data-protection",
  fr: "/fr/protection-des-donnees",
}

export { privacyLinks }
